// LA FECHA DEL ESTADO DE CUENTA DE COMISIONES — la del pago, no la de la póliza.
//
// Wendy Cercio (Insurance Latino), 2026-10-28: *"cuando le subo el estado de
// cuenta a Comisiones me aparecen saldos en 2025 y 2024; revisando me doy
// cuenta que son las fechas en que empezaron a ser mis clientes, pero no está
// tomando el mes de comisión correspondiente"*.
//
// El "Acosta Commission Report" (Medicare) trae la fecha del pago ARRIBA, sola
// en su línea ("01/31/2026"), y en cada fila la fecha de EFECTIVIDAD de la
// póliza ("2024-11-01"); la columna "Comm Period" viene vacía. El lector tomaba
// la de cada fila, así que un pago de enero de 2026 caía en noviembre de 2024.
//
// Aquí se busca la fecha del estado de cuenta: primero una fecha sola en una
// línea del encabezado (antes de la tabla); si no, una del nombre del archivo
// ("MEDICARE_01_31_2026_crm.pdf"). Sin ninguna de las dos, null: se sigue como
// antes, con la de cada fila.

const MAX_LINEAS_DE_ENCABEZADO = 12;

function fecha(mes, dia, anio) {
  const m = Number(mes), d = Number(dia), y = Number(anio);
  if (!(m >= 1 && m <= 12 && d >= 1 && d <= 31 && y >= 2000 && y <= 2100)) return null;
  const f = new Date(y, m - 1, d); // día LOCAL, nunca UTC
  return f.getMonth() === m - 1 ? f : null;
}

/** La fecha del estado de cuenta, o null. `lineas`: el texto del PDF por líneas. */
export function fechaDelEstadoDeCuenta(lineas, nombreDelArchivo) {
  const ls = (Array.isArray(lineas) ? lineas : []).map((l) => String(l || '').replace(/\t/g, ' ').trim()).filter(Boolean);
  for (const l of ls.slice(0, MAX_LINEAS_DE_ENCABEZADO)) {
    // Al llegar a la tabla se deja de mirar: las fechas de ahí son de las pólizas.
    if (/\b(client name|member name|policy #)\b/i.test(l)) break;
    const m = l.match(/^(?:statement date:?\s*|payment date:?\s*|fecha:?\s*)?(\d{1,2})\/(\d{1,2})\/(\d{4})$/i);
    if (m) { const f = fecha(m[1], m[2], m[3]); if (f) return f; }
  }
  const n = String(nombreDelArchivo || '').match(/(?:^|[^\d])(\d{1,2})[_\-.](\d{1,2})[_\-.](\d{4})(?:[^\d]|$)/);
  if (n) { const f = fecha(n[1], n[2], n[3]); if (f) return f; }
  return null;
}
